const initState = {
  poDocuments: [],
}

export default initState
